import { api } from './auth.service';

const negocioService = {

  listar: async () => {
    const res = await api.get('/negocios');
    return res.data;
  },

  buscarPorId: async (id, usuarioId) => {
    const res = await api.get(`/negocios/${id}`, {
      params: { usuario_id: usuarioId || undefined },
    });
    return res.data;
  },

  // Lista negócios "Originais" do cliente (para combo de Aditivo)
  listarParaAditivo: async (clienteId, excluirId) => {
    const params = excluirId ? `?excluir_id=${excluirId}` : '';
    const res = await api.get(`/negocios/aditivar/${clienteId}${params}`);
    return res.data;
  },

  incluir: async (dados) => {
    const res = await api.post('/negocios', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/negocios/${id}`, dados);
    return res.data;
  },

  // Alterar apenas a etapa comercial (usado pelo mini-menu no browse)
  alterarEtapa: async (id, etapa) => {
    const res = await api.patch(`/negocios/${id}/etapa`, { etapa });
    return res.data;
  },

  // Alterar apenas a temperatura (Quente/Morno/Frio) via mini-menu no browse
  alterarTemperatura: async (id, temperatura) => {
    const res = await api.patch(`/negocios/${id}/temperatura`, { temperatura });
    return res.data;
  },

  // Atualiza etapa via sugestão automática (ex: após anexo na Levantamento)
  // Cria evento na timeline + muda etapa do negócio em uma transação
  atualizarEtapaSugerida: async (id, dados) => {
    const res = await api.patch(`/negocios/${id}/etapa-sugerida`, dados);
    return res.data;
  },

  // Altera etapa via modal de alteração com regras de negócio
  // (avanço/retroagimento adjacente, perdido livre, validações server-side)
  alterarEtapaModal: async (id, dados) => {
    const res = await api.patch(`/negocios/${id}/alterar-etapa-modal`, dados);
    return res.data;
  },

  // Define a data inicial da etapa Oportunidade. Chamado logo após incluir().
  // Body: { data_evento (YYYY-MM-DD), usuario_id }
  definirDataOportunidade: async (id, dados) => {
    const res = await api.post(`/negocios/${id}/definir-data-oportunidade`, dados);
    return res.data;
  },

  // Excluir permanentemente (só funciona se etapa = Oportunidade)
  excluir: async (id) => {
    const res = await api.delete(`/negocios/${id}`);
    return res.data;
  },

   alterarEtapaTecnica: async (id, dados) => {
    const res = await api.patch(`/negocios/${id}/etapa-tecnica`, dados);
    return res.data;
  },

fechadosNoPeriodo: async (mes, ano) => {
    const res = await api.get('/negocios/fechados-periodo', { params: { mes, ano } });
    return res.data;
  },

};

export default negocioService;
